import React from 'react';
import { useSelector } from 'react-redux';

import { queryMapper, searchRegexLanguageParser } from '@neptune/compound-search-domain';
import { MyRunsSearchMode } from '@neptune/home-page-domain';
import { SearchQuery } from '@neptune/search-query-domain';

import { KnownAttributes } from 'domain/experiment/attribute';
import { getCurrentUsername } from 'state/users/current-user/selectors';

import { myRunsStore } from './my-runs-storage';
import { useMyRunsSearchMode } from './use-my-runs-search-mode';

export const useUsernameAndMyFilterSearchQuery = () => {
  const experimentRegex = myRunsStore.getRegex();
  const username = useSelector(getCurrentUsername);
  const { myRunsSearchMode } = useMyRunsSearchMode();
  const experimentRegexQuery: SearchQuery | undefined = React.useMemo(() => {
    if (!experimentRegex) {
      return;
    }

    const myRunsSearchRegexQueryParseResult = searchRegexLanguageParser.parse(experimentRegex);

    if (myRunsSearchRegexQueryParseResult.status !== 'valid') {
      return;
    }

    return queryMapper.mapRegexQueryToSearchQuery(myRunsSearchRegexQueryParseResult.query);
  }, [experimentRegex]);

  const usernameQuery: SearchQuery = React.useMemo(
    () => ({
      criteria: [
        {
          attribute: KnownAttributes.Owner,
          operator: '=',
          type: 'string',
          value: username,
        },
      ],
      operator: 'and',
    }),
    [username],
  );

  const usernameAndMyRunsFilterQuery: SearchQuery | undefined = React.useMemo(
    () =>
      myRunsSearchMode === MyRunsSearchMode.MY
        ? {
            criteria: [usernameQuery, ...(experimentRegexQuery ? [experimentRegexQuery] : [])],
            operator: 'or',
          }
        : undefined,
    [usernameQuery, experimentRegexQuery, myRunsSearchMode],
  );

  return {
    usernameAndMyRunsFilterQuery,
  };
};
